import { render, staticRenderFns } from "./novel-apply.vue?vue&type=template&id=98dc33b0&scoped=true"
import script from "./novel-apply.vue?vue&type=script&lang=js"
export * from "./novel-apply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dc33b0",
  null
  
)

export default component.exports